// extracted by mini-css-extract-plugin
export var container = "_sx-0";
export var table = "_sx-2";
export var tableWrapper = "_sx-1";